import { AppServer } from "./app-server.model";
import { PortalUser } from "./portal-user.model";

export class AdditionalOwnership {
    appServerDtos: Array<AppServer>;
    userDtos: Array<PortalUser>;
}
